import { Injectable } from '@angular/core';

import { BreadcrumbItem } from '@mitsubishi/shared/ui';

import { Action, State, StateContext } from '@ngxs/store';

import { SetBreadcrumbs } from './breadcrumbs.actions';

@State<BreadcrumbItem[]>({
  name: 'breadcrumbs',
  defaults: [],
})
@Injectable()
export class ProjectBreadcrumbsState {
  @Action(SetBreadcrumbs)
  setBreadcrumbs(ctx: StateContext<BreadcrumbItem[]>, { breadcrumbs }: SetBreadcrumbs) {
    ctx.setState(breadcrumbs);
  }
}
